import { useQuery, UseQueryResult } from "react-query";

import { GET_ALL_DOCUMENT_REQUESTS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getAllDocumentRequestsAsync } from "api/customers";

interface DocumentRequest {
  id: number;
  [key: string]: any;
}

interface UseGetAllDocumentRequestsReturn {
  documentRequests: DocumentRequest[];
  documentRequestsLoading: boolean;
  refetchDocumentRequests: () => void;
}

/**
 * The useGetAllDocumentRequests hook fetches all document requests for a given client.
 * @param clientId - The client ID.
 */
const useGetAllDocumentRequests = (clientId?: string | number): UseGetAllDocumentRequestsReturn & Omit<UseQueryResult, 'data' | 'isLoading' | 'refetch'> => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_ALL_DOCUMENT_REQUESTS, clientId],
    () => getAllDocumentRequestsAsync(clientId),
    {
      enabled: Boolean(clientId),
      staleTime: STALE_TIME_5_MINUTES,
      retry: false,
    }
  );

  return {
    documentRequests: data?.data || [],
    documentRequestsLoading: isLoading,
    refetchDocumentRequests: refetch,
    ...rest,
  };
};

export default useGetAllDocumentRequests;
